<app-side-menu>
  <div class="agreement-form-container">
    <div class="page-header">
      <button class="btn btn-outline-secondary btn-sm" (click)="back()">
        <i class="fas fa-arrow-left"></i> Voltar
      </button>
      <h2 *ngIf="isCreateMode">Novo Acordo</h2>
      <h2 *ngIf="isViewMode">Acordo {{ agreement.agreementNumber }}</h2>
      <h2 *ngIf="isEditMode">Editar Acordo {{ agreement.agreementNumber }}</h2>
    </div>

    <div *ngIf="loading" class="text-center py-4">
      <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div *ngIf="error" class="alert alert-danger alert-dismissible">
      {{ error }}
      <button type="button" class="btn-close" (click)="error = ''"></button>
    </div>

    <div *ngIf="successMessage" class="alert alert-success alert-dismissible">
      {{ successMessage }}
      <button type="button" class="btn-close" (click)="successMessage = ''"></button>
    </div>

    <!-- VIEW MODE -->
    <ng-container *ngIf="(isViewMode || isEditMode) && !loading">
      <div class="card mb-4">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span>Detalhes do Acordo</span>
          <span class="badge" [ngClass]="{
            'bg-warning text-dark': agreement.status === 'Pendente',
            'bg-info text-dark': agreement.status === 'Ativo',
            'bg-success': agreement.status === 'Quitado',
            'bg-danger': agreement.status === 'Cancelado'
          }">{{ agreement.status }}</span>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-3">
              <label class="form-label text-muted">Número</label>
              <p class="fw-semibold">{{ agreement.agreementNumber }}</p>
            </div>
            <div class="col-md-3">
              <label class="form-label text-muted">Cliente</label>
              <p>{{ agreement.customerName }}</p>
            </div>
            <div class="col-md-3">
              <label class="form-label text-muted">Locação</label>
              <p>{{ agreement.vehicleRentalNumber }}</p>
            </div>
            <div class="col-md-3">
              <label class="form-label text-muted">Vencimento</label>
              <p>{{ agreement.dueDate | date:'dd/MM/yyyy' }}</p>
            </div>
            <div class="col-md-3">
              <label class="form-label text-muted">Valor Original</label>
              <p>{{ agreement.totalOriginalAmount | currency:'BRL' }}</p>
            </div>
            <div class="col-md-3">
              <label class="form-label text-muted">Valor Acordado</label>
              <p class="text-success fw-semibold">{{ agreement.totalAgreedAmount | currency:'BRL' }}</p>
            </div>
            <div class="col-md-3">
              <label class="form-label text-muted">Desconto</label>
              <p class="text-danger">{{ agreement.discount | currency:'BRL' }}</p>
            </div>
            <div class="col-md-3">
              <label class="form-label text-muted">Parcelas</label>
              <p>{{ agreement.installments }}x</p>
            </div>
            <div class="col-12" *ngIf="agreement.notes">
              <label class="form-label text-muted">Observações</label>
              <p>{{ agreement.notes }}</p>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex gap-2" *ngIf="isViewMode && agreement.status !== 'Cancelado' && agreement.status !== 'Quitado'">
          <button class="btn btn-danger btn-sm" (click)="cancel()">
            <i class="fas fa-ban"></i> Cancelar Acordo
          </button>
        </div>
      </div>

      <!-- Items -->
      <div class="card mb-4" *ngIf="agreement.items && agreement.items.length > 0">
        <div class="card-header">Itens do Acordo</div>
        <div class="card-body p-0">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>Descrição</th>
                <th>Tipo</th>
                <th>Valor Original</th>
                <th>Valor Acordado</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of agreement.items">
                <td>{{ item.description }}</td>
                <td>{{ item.sourceType }}</td>
                <td>{{ item.originalAmount | currency:'BRL' }}</td>
                <td>{{ item.agreedAmount | currency:'BRL' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Payments -->
      <div class="card mb-4" *ngIf="payments.length > 0">
        <div class="card-header">Parcelas</div>
        <div class="card-body p-0">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Vencimento</th>
                <th>Valor</th>
                <th>Status</th>
                <th>Pago em</th>
                <th>Método</th>
                <th *ngIf="agreement.status !== 'Cancelado' && agreement.status !== 'Quitado'">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of payments">
                <td>{{ p.installmentNumber }}</td>
                <td>{{ p.dueDate | date:'dd/MM/yyyy' }}</td>
                <td>{{ p.amount | currency:'BRL' }}</td>
                <td>
                  <span class="badge" [ngClass]="{
                    'bg-warning text-dark': p.status === 'Pendente',
                    'bg-success': p.status === 'Pago',
                    'bg-danger': p.status === 'Vencido'
                  }">{{ p.status }}</span>
                </td>
                <td>{{ p.paidAt | date:'dd/MM/yyyy' }}</td>
                <td>{{ p.paymentMethod }}</td>
                <td *ngIf="agreement.status !== 'Cancelado' && agreement.status !== 'Quitado'">
                  <button
                    *ngIf="p.status !== 'Pago'"
                    class="btn btn-sm btn-success"
                    (click)="openPayModal(p.id)">
                    <i class="fas fa-check"></i> Pagar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <!-- CREATE MODE -->
    <ng-container *ngIf="isCreateMode">
      <div class="card mb-4">
        <div class="card-header">Dados do Acordo</div>
        <div class="card-body">
          <div class="row g-3">

            <!-- Customer search -->
            <div class="col-md-6">
              <label class="form-label">Cliente *</label>
              <div class="position-relative customer-picker">
                <div class="input-group">
                  <button
                    *ngIf="!selectedCustomer"
                    type="button"
                    class="btn btn-outline-secondary"
                    (click)="onCustomerFieldActivate()"
                    title="Ver todos os clientes">
                    <i class="fas fa-users"></i>
                  </button>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Clique ou digite para buscar cliente..."
                    [(ngModel)]="customerSearchTerm"
                    (focus)="onCustomerFieldActivate()"
                    (click)="onCustomerFieldActivate()"
                    (input)="onCustomerSearchInput()"
                    (blur)="onCustomerFieldBlur()"
                    [disabled]="!!selectedCustomer"
                    autocomplete="off" />
                  <button *ngIf="selectedCustomer" class="btn btn-outline-secondary" type="button" (click)="clearCustomer()" title="Limpar cliente">
                    <i class="fas fa-times"></i>
                  </button>
                  <span *ngIf="loadingCustomers" class="input-group-text">
                    <span class="spinner-border spinner-border-sm"></span>
                  </span>
                </div>
                <div
                  *ngIf="showCustomerDropdown && !selectedCustomer"
                  class="customer-dropdown shadow-sm"
                  (mousedown)="$event.preventDefault()">
                  <div class="customer-dropdown-head" *ngIf="!loadingCustomers && customerResults.length > 0">
                    <span>{{ customerResults.length }} de {{ customerListTotal }} cliente(s)</span>
                    <small class="text-muted" *ngIf="customerSearchTerm.trim().length >= 1"> — filtro: "{{ customerSearchTerm.trim() }}"</small>
                    <small class="text-muted" *ngIf="customerSearchTerm.trim().length < 1"> — todos carregados</small>
                  </div>
                  <div *ngIf="loadingCustomers" class="customer-dropdown-empty">
                    <span class="spinner-border spinner-border-sm text-primary me-2"></span>
                    Carregando clientes...
                  </div>
                  <ul *ngIf="!loadingCustomers && customerResults.length > 0" class="list-group list-group-flush mb-0">
                    <li
                      *ngFor="let c of customerResults"
                      class="list-group-item list-group-item-action py-2 px-3 customer-dropdown-item"
                      (mousedown)="selectCustomer(c)">
                      <span class="fw-semibold">{{ c.name }}</span>
                      <small class="text-muted d-block" *ngIf="c.documentNumber">{{ c.documentNumber }}</small>
                      <small class="text-muted" *ngIf="c.email">{{ c.email }}</small>
                    </li>
                  </ul>
                  <div *ngIf="!loadingCustomers && customerResults.length === 0" class="customer-dropdown-empty">
                    <i class="fas fa-search me-1"></i>
                    Nenhum cliente encontrado.
                    <span *ngIf="customerSearchTerm.trim().length < 1"> Clique no ícone de clientes para recarregar a lista.</span>
                  </div>
                </div>
              </div>
              <small class="text-muted" *ngIf="!selectedCustomer">Ao abrir o campo, todos os clientes são listados; digite para filtrar.</small>
              <div class="alert alert-light border py-2 px-3 mt-2 mb-0" *ngIf="selectedCustomer">
                <i class="fas fa-user-check text-success me-2"></i>
                Cliente vinculado: <strong>{{ selectedCustomerLabel }}</strong>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label">Data de Vencimento *</label>
              <input type="date" class="form-control" [(ngModel)]="dueDate" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Parcelas</label>
              <input type="number" class="form-control" [(ngModel)]="installments" min="1" max="60" />
            </div>
            <div class="col-12">
              <label class="form-label">Observações</label>
              <textarea class="form-control" [(ngModel)]="notes" rows="2"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
          <span>Pendências Financeiras</span>
          <small class="text-muted" *ngIf="selectedTitlesCount > 0">
            {{ selectedTitlesCount }} título(s) selecionado(s)
            <span *ngIf="selectedBoletosCount > 0"> · {{ selectedBoletosCount }} pagamento(s) em cancel-batch</span>
          </small>
        </div>
        <div class="card-body">
          <div *ngIf="loadingReceivables" class="text-center py-3">
            <div class="spinner-border spinner-border-sm text-primary"></div>
          </div>
          <div *ngIf="!loadingReceivables && pendingReceivables.length === 0" class="text-muted">
            Nenhuma pendência encontrada para este cliente.
          </div>
          <table *ngIf="pendingReceivables.length > 0" class="table table-sm">
            <thead>
              <tr>
                <th>Sel.</th>
                <th>Documento</th>
                <th>Descrição</th>
                <th>Vencimento</th>
                <th>Valor a Receber</th>
                <th>Valor Acordado</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let r of pendingReceivables">
                <tr [class.table-primary]="r.selected">
                  <td>
                    <input type="checkbox" [checked]="r.selected" (change)="toggleReceivable(r)" />
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-link btn-sm p-0 me-1"
                      *ngIf="r.boletos.length > 0"
                      (click)="toggleBoletosExpanded(r)"
                      [attr.aria-expanded]="r.boletosExpanded">
                      <i class="fas" [class.fa-chevron-down]="r.boletosExpanded" [class.fa-chevron-right]="!r.boletosExpanded"></i>
                    </button>
                    {{ r.documentNumber }}
                  </td>
                  <td>{{ r.description }}</td>
                  <td>{{ r.dueDate | date:'dd/MM/yyyy' }}</td>
                  <td>{{ r.amountToReceive | currency:'BRL' }}</td>
                  <td>
                    <div class="input-group input-group-sm money-input-sm">
                      <span class="input-group-text">R$</span>
                      <input
                        type="text"
                        class="form-control text-end"
                        [disabled]="!r.selected"
                        [value]="formatMoneyBr(r.agreedAmount)"
                        (focus)="onMoneyFocus($event, r.agreedAmount)"
                        (input)="onMoneyInput($event, 'line', r)"
                        inputmode="decimal"
                        autocomplete="off"
                        placeholder="0,00" />
                    </div>
                  </td>
                  <td>{{ r.status }}</td>
                </tr>
                <tr *ngIf="r.boletosExpanded" class="boletos-detail-row">
                  <td colspan="7" class="p-0">
                    <div class="boletos-panel px-3 py-2">
                      <div *ngIf="r.loadingBoletos" class="text-muted small py-2">
                        <span class="spinner-border spinner-border-sm me-2"></span>
                        Carregando boletos...
                      </div>
                      <p class="text-muted small mb-2" *ngIf="!r.loadingBoletos && r.boletos.length === 0 && r.selected">
                        <i class="fas fa-exchange-alt me-1"></i>
                        Título será substituído pelo acordo (marcado como cancelado ao confirmar).
                      </p>
                      <p class="text-muted small mb-2" *ngIf="!r.loadingBoletos && r.boletos.length === 0 && !r.selected">
                        Sem boletos vinculados. Marque o título para incluí-lo no acordo.
                      </p>
                      <ul class="list-unstyled mb-0" *ngIf="!r.loadingBoletos && r.boletos.length > 0">
                        <li *ngFor="let b of r.boletos" class="boletos-panel-item d-flex align-items-center gap-2 py-1">
                          <input
                            type="checkbox"
                            [checked]="b.cancelSelected"
                            [disabled]="!isPaymentCancellable(b)"
                            (change)="toggleBoletoCancel(r, b)" />
                          <span [class.text-muted]="!isPaymentCancellable(b)">
                            {{ formatBoletoLabel(b) }}
                            <span class="badge ms-1" [ngClass]="{
                              'bg-secondary': b.status === 'Pendente',
                              'bg-success': b.status === 'Confirmado',
                              'bg-danger': b.status === 'Cancelado'
                            }">{{ b.status || '—' }}</span>
                          </span>
                        </li>
                      </ul>
                      <small class="text-muted d-block mt-2" *ngIf="hasTitleSubstitution(r)">
                        Este título entra no acordo e será cancelado/substituído ao confirmar.
                      </small>
                      <small class="text-muted d-block mt-2" *ngIf="r.selected && r.boletos.length > 0">
                        Boletos e cobranças pré-selecionados; desmarque apenas o que não deve ser cancelado.
                      </small>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>

          <div class="totals-row mt-3" *ngIf="hasSelectedReceivables">
            <div class="row g-2 align-items-end">
              <div class="col-md-6 col-lg-3">
                <label class="form-label text-muted">Total Original</label>
                <div class="input-group">
                  <span class="input-group-text">R$</span>
                  <input
                    type="text"
                    class="form-control text-end fw-semibold money-readonly"
                    [value]="formatMoneyBr(agreement.totalOriginalAmount)"
                    readonly
                    tabindex="-1" />
                </div>
              </div>
              <div class="col-md-6 col-lg-3">
                <label class="form-label text-muted">Total Acordado</label>
                <div class="input-group">
                  <span class="input-group-text">R$</span>
                  <input
                    type="text"
                    class="form-control text-end"
                    [value]="formatMoneyBr(agreement.totalAgreedAmount)"
                    (focus)="onMoneyFocus($event, agreement.totalAgreedAmount)"
                    (input)="onMoneyInput($event, 'agreed')"
                    inputmode="decimal"
                    autocomplete="off"
                    placeholder="0,00" />
                </div>
              </div>
              <div class="col-md-6 col-lg-3">
                <label class="form-label text-muted">Desconto (%)</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control text-end"
                    [value]="formatPercentBr(discountPercent)"
                    (focus)="onDiscountPercentFocus($event)"
                    (input)="onDiscountPercentInput($event)"
                    inputmode="decimal"
                    autocomplete="off"
                    placeholder="0" />
                  <span class="input-group-text">%</span>
                </div>
              </div>
              <div class="col-md-6 col-lg-3">
                <label class="form-label text-muted">Desconto (R$)</label>
                <div class="input-group">
                  <span class="input-group-text">R$</span>
                  <input
                    type="text"
                    class="form-control text-end"
                    [value]="formatMoneyBr(agreement.discount)"
                    (focus)="onMoneyFocus($event, agreement.discount)"
                    (input)="onMoneyInput($event, 'discount')"
                    inputmode="decimal"
                    autocomplete="off"
                    placeholder="0,00" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex gap-2">
        <button class="btn btn-primary" (click)="save()" [disabled]="saving || cancellingBoletos">
          <span *ngIf="saving || cancellingBoletos" class="spinner-border spinner-border-sm me-1"></span>
          {{ cancellingBoletos ? 'Cancelando boletos...' : 'Criar Acordo' }}
        </button>
        <button class="btn btn-outline-secondary" (click)="back()">Cancelar</button>
      </div>
    </ng-container>
  </div>

  <!-- Pay Modal -->
  <div class="modal fade" [class.show]="selectedPaymentId !== null" [style.display]="selectedPaymentId !== null ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Registrar Pagamento</h5>
          <button type="button" class="btn-close" (click)="selectedPaymentId = null"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Forma de Pagamento</label>
            <select class="form-select" [(ngModel)]="paymentMethod">
              <option *ngFor="let m of paymentMethods" [value]="m">{{ m }}</option>
            </select>
          </div>
          <div class="mb-3">
            <label class="form-label">Comprovante (opcional)</label>
            <input type="text" class="form-control" [(ngModel)]="receipt" placeholder="Número do comprovante" />
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="selectedPaymentId = null">Fechar</button>
          <button class="btn btn-success" (click)="confirmPayment()">Confirmar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" *ngIf="selectedPaymentId !== null"></div>
</app-side-menu>
